export default __webpack_public_path__ + "static/Greycliffcf-demibold-webfont-13653762533afa55aa55b30610762e43.woff";